import React from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";
import AppScreenshotsSection from "./AppScreenshotsSection";
import ScrollingCustomers from "./ScrollingCustomers";
import FeaturesSection from "./FeaturesSection";
import WhySkhool from "./WhySchool";
import Testimonials from "./Testimonials";
import CTASection from "./CTASection";
import Footer from "./Footer";
import SeoFaqSection from "./SeoFaqSection";

const LandingPage = () => {
  return (
    <div
      className="bg-white text-gray-900"
      style={{
        background:
          'linear-gradient(180deg, #fffaf5 0%, #ffffff 18%, #f8fbff 38%, #ffffff 100%)',
      }}
    >

      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <section id="hero">
        <Hero />
      </section>

      {/* Product Screenshots */}
      <section id="app-showcase">
        <AppScreenshotsSection />
      </section>

      {/* Trusted by Schools */}
      <section
        id="customers"
        className="py-10 bg-gray-50"
        style={{
          background:
            'linear-gradient(180deg, #fff7ed 0%, #fffdf8 45%, #ffffff 100%)',
        }}
      >
        <ScrollingCustomers />
      </section>

      {/* Features */}
      <section
        id="features-section"
        className="py-14"
        style={{
          background:
            'linear-gradient(180deg, #ffffff 0%, #fffaf5 100%)',
        }}
      >
        <FeaturesSection />
      </section>

      {/* Why Skhool */}
      <section
        id="features-benefits"
        className="py-14 bg-gray-50"
        style={{
          background:
            'linear-gradient(180deg, #fdf2f8 0%, #eff6ff 100%)',
        }}
      >
        <WhySkhool />
      </section>

      {/* Testimonials */}
      <section id="testimonials" className="py-14">
        <Testimonials />
      </section>

      {/* SEO FAQ */}
      <section id="seo-faq" className="py-8 bg-gray-50">
        <SeoFaqSection />
      </section>

      {/* CTA */}
      <section id="contact-section">
        <CTASection />
      </section>

      {/* Footer */}
      <Footer id="contact" />

    </div>
  );
};

export default LandingPage;
